<template>
	<div :class="classNames">
		<div :class="classNames+ '_search'">
			<!-- <el-button type="primary" @click="createClass">新建课程</el-button> -->
			<div :class="classNames+ '_search_con'">
				<div :class="classNames+ '_search_con_item'" style="width:260px;">
					<span :class="classNames+ '_search_con_item_title'">订单编号</span>
					<el-input placeholder="" v-model="searchObj.order_no"></el-input>
				</div>
				<div :class="classNames+ '_search_con_item'">
					<span :class="classNames+ '_search_con_item_title'">支付时间</span>
					<!-- <el-date-picker v-model="times" type="daterange" range-separator="至" start-placeholder="开始日期"
						end-placeholder="结束日期" @change="changeTime" value-format="yyyy-MM-dd">
					</el-date-picker> -->
					<el-date-picker v-model="times" type="datetimerange" range-separator="至" start-placeholder="开始日期"
     					end-placeholder="结束日期" @change="changeTime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
    				</el-date-picker> 
				</div>
				<div v-if="searchObj.channel_type==1" :class="classNames+ '_search_con_item'" style="width:190px;">
					<span :class="classNames+ '_search_con_item_title'">来源</span>
					<el-select v-model="searchObj.scene" @change="changeScene">
						<el-option v-for="(item, index) in sceneList" :label="item.label" :value="item.value" :key="index"></el-option>
					</el-select>
				</div>
				<template v-if="openlist">

				<!-- <div :class="classNames+ '_search_con_item'">
					<span :class="classNames+ '_search_con_item_title'">快手账号</span>
					<el-select v-model="searchObj.dycode" @change="changeScene">
						<el-option label="全部" value=""></el-option>
						<el-option v-for="item in channelAccountList" :label="item.nickname" :value="item.id" :key="item.id"></el-option>
					</el-select>
				</div> -->
				<!-- <div :class="classNames+ '_search_con_item'">
					<span :class="classNames+ '_search_con_item_title'">推广人&nbsp;&nbsp;&nbsp;</span>
					<el-input placeholder="请输入推广人昵称" v-model="searchObj.nickname"></el-input>
				</div> -->
				<div :class="classNames+ '_search_con_item'">
					<span :class="classNames+ '_search_con_item_title'">订单状态</span>
					<el-select v-model="searchObj.status" @change="changeScene">
						<el-option v-for="(item, index) in stateList" :label="item.label" :value="item.value" :key="index"></el-option>
					</el-select>
				</div>
				<div :class="classNames+ '_search_con_item'">
					<span :class="classNames+ '_search_con_item_title'">课程标题</span>
					<el-select v-model="searchObj.product_id" clearable filterable>
						<el-option v-for="(item, index) in productList" :label="item.title" :value="item.id" :key="index"></el-option>
					</el-select>
				</div>
				<div :class="classNames+ '_search_con_item'">
					<span :class="classNames+ '_search_con_item_title'">手机号&nbsp;&nbsp;&nbsp;</span>
					<el-input placeholder="请输入手机号" v-model="searchObj.phone"></el-input>
				</div>
				<div :class="classNames+ '_search_con_item'">
					<span :class="classNames+ '_search_con_item_title'">收益状态</span>
					<el-select v-model="searchObj.income_status" @change="changeScene">
						<el-option v-for="(item, index) in profitStatus" :label="item.label" :value="item.value" :key="index"></el-option>
					</el-select>
				</div>
				<div :class="classNames+ '_search_con_item'">
					<span :class="classNames+ '_search_con_item_title'">支付来源</span>
					<el-select v-model="searchObj.pay_channel" @change="changeScene">
						<el-option v-for="(item, index) in paySources" :label="item.label" :value="item.value" :key="index"></el-option>
					</el-select>
				</div>
				<div v-if="searchObj.channel_type==1" :class="classNames+ '_search_con_item'">
					<span :class="classNames+ '_search_con_item_title'">购买人昵称&nbsp;&nbsp;&nbsp;</span>
					<el-input placeholder="请输入购买人昵称" v-model="searchObj.buyer_nickname"></el-input>
				</div>
				<!-- <div :class="classNames+ '_search_con_item'">
					<span :class="classNames+ '_search_con_item_title'">买家昵称</span>
					<el-input placeholder="" v-model="searchObj.nick_name"></el-input>
				</div> -->
				</template>

				<div :class="[classNames+ '_search_con_item', classNames+ '_oprtation']">
				<el-button type="primary" @click="searchRes">查询</el-button>
				<el-button type="primary" @click="exportExcel">导出</el-button>
				<el-button style="border:none;" v-if="!openlist" icon="el-icon-arrow-down" @click="openlist=true">高级筛选</el-button>
					<el-button style="border:none;" v-if="openlist" icon="el-icon-arrow-up" @click="openlist=false">收起</el-button>
					<el-button type="primary" @click="getUserMobileAuth(true)" v-if="isShowAuthMobile == 2">获取购买用户完整手机号</el-button>
					<table-tools-head :data="tableHeadTitle" :selData="checkedHeadTitles" @titlesChange="handleCheckedHeadTitlesChange"></table-tools-head>
					<span class="total_sums">共{{orderInfo.total}}条</span>
				</div>
			</div>
		</div>
		<!-- <div :class="classNames + '_statistics'">
			<span>订单总金额：{{orderInfo.order_all}}元</span>
			<span>实际总收益：{{orderInfo.order_author_all}}元</span>
		</div> -->
		<div :class="classNames+'_con'">
			<div :class="classNames+'_con_table'">
				<el-table :data="orderInfo.list"
					:header-cell-style="{background: '#F5F7FA',color:'#454D53'}" :cell-style="cellStyle">
					<div slot="empty">
						<img :src="require(`@/assets/image/${noDataName}.png`)" style="width: 100%;padding: 115px 0;"/>
					</div>
					<el-table-column :label="item.label" :prop="item.prop" v-for="(item, index) in tableHeadTitleShow"
						:type="item.prop" :key="index" :width="item.width" :align="item.align">
						<template slot-scope="scope">
							<div v-if="item.prop === 'status'">
								<div v-if="scope.row.status == 4" class="buy">已购买</div>
								<div v-if="scope.row.status == 7" class="buy refund">已退款</div>
								<div v-if="scope.row.status == 2" class="buy refund1">待支付</div>
								<div v-if="scope.row.status == 9" class="buy refund">退款中</div>
								<div v-if="scope.row.status == 10" class="buy refund">退款拒绝</div>
							</div>
							<div v-else-if="item.prop === 'product_title'">
								<div :class="classNames+'_empty'"></div>
								<div :class="classNames+'_item'">
									<span style="min-width:220px">订单编号：{{scope.row.order_no}}</span>
									<!-- <span>支付时间：{{scope.row.pay_time}}</span> -->
									<!-- <span>手机号：{{scope.row.mobile ? scope.row.mobile : '--'}}</span>
									<span>来源：{{scope.row.scene_value || '--'}}</span> -->
									<span>下单时间：{{scope.row.created_time||'--'}}</span>
									<span>支付时间：{{scope.row.pay_time||'--'}}</span>
								</div>
								{{scope.row[item.prop]}}
							</div>
							<div v-else-if="item.prop === 'nick_nake'" class="header_avatar">
								<el-avatar size="small" v-if="scope.row.avatar_url" :src="scope.row.avatar_url"></el-avatar>
								{{scope.row.nick_nake}}
							</div>
							<div v-else-if="item.prop === 'pay_channel'">
								{{ scope.row[item.prop]==4 ? 'h5' : '小程序' }}
							</div>
							<div v-else>{{scope.row[item.prop]}}</div>
						</template>
					</el-table-column>
					<el-table-column label="备注"  min-width="100">
						<template slot-scope="scope">
							<div>
								<el-tooltip v-if="!scope.row.tips_status" effect="dark" placement="top-start" :content="scope.row.remark_author" :disabled="!scope.row.remark_author.trim()">
									<div style="color:#409eff;cursor:pointer;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width:100px;" @click="hiddenTips(scope)">{{scope.row.remark_author.trim()?scope.row.remark_author:'添加备注'}}</div>
								</el-tooltip>
								<el-input v-else placeholder="添加备注" v-model="scope.row.remark_author" @blur="showTips(scope)"></el-input>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="100" fixed="right">
						<template slot-scope="scope">
							<span @click="capitaletails(scope.row)" :class="classNames+'_operation_title'">详情</span>
							<span @click="capitaleLearnRecords(scope.row)" :class="classNames+'_operation_title'" v-if="scope.row.status == 4">学习记录</span>
							<span @click="refundFun(scope.row)" :class="classNames+'_operation_title'" v-if="scope.row.is_refund == 1">退款</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<Pagination @change="changeSize" :total="orderInfo.total" ref="pagination" v-if="showPagination" v-model="searchObj.page"></Pagination>
		</div>
		<el-dialog title="资金明细" :visible.sync="dialogTableVisible" :custom-class="classNames + '_detailed'" :modal="false" :close-on-click-modal="false" :close-on-press-escape="false">
		  <el-table :data="tableList" :header-cell-style="{background: '#F5F7FA',color:'#454D53'}" :row-class-name="rowClassName">
		    <el-table-column v-for="(item, index) in popHeaderList" :key="index" :prop="item.prop" :label="item.label">
				<template slot-scope="scope">
					<span v-if="scope.row[item.prop] != 0">{{scope.row[item.prop]}}</span>
				</template>
			</el-table-column>
		  </el-table>
		</el-dialog>
		<drawer v-model="drawerFlag" :id="detail_id" :channel_type="searchObj.channel_type" :showFlag="true" @editRmark="drawerEditRmark"></drawer>
		<drawer-learn v-model="drawerLearnFlag" :id="learning_id" :channel_type="searchObj.channel_type"></drawer-learn>
		<httpsDialog v-model="showMobileAuth"></httpsDialog>
		<orderRefund v-model="refundVisible"  :channel_type="searchObj.channel_type" :id="detail_id" @result="refundSuccess"></orderRefund>
	</div>
</template>

<script>
	import {
		data
	} from './data.js'
	import {
		mapState,
		mapActions
	} from 'vuex'
	import Pagination from '@/components/pagination/pagination.vue'
	import drawer from '@/components/drawer/drawer.vue'
	import drawerLearn from '@/components/drawerLearn/drawerLearn.vue'
	import tableToolsHead from '@/components/tableToolsHead/tableToolsHead.vue'
	// import mobileDialog from '@/components/mobileDialog/mobileDialog.vue'
	import httpsDialog from '@/components/mobileDialog/httpsDialog.vue'


	import axios from 'axios'
	import md5 from 'md5'
	import { getBaseUrl } from '@/utils/baseUrl.js'
	import refundMiXin from '@/pages/components/orderRefund/mixin.js'
	import * as dayjs from 'dayjs'
	export default {
		name: 'Order',
		mixins: [data,refundMiXin],
		data() {
			return {
				classNames: 'order',
				times: [],
				popHeaderList: [
					{
						prop: 'role',
						label: '角色'
					},
					{
						prop: 'profit',
						label: '收益'
					}
				],
				searchObj: {
					page:1,
					page_size:10,
					start_time: '',
					end_time:'',
					// nick_name: '',
					order_no: '',
					scene: '',
					dycode: '',
					nickname: '',
					buyer_nickname: '',
					product_id: '',
					phone: '',
					income_status:'',
					channel_type:1,
					pay_channel: '', // 支付来源
				},
				paySources: [ // 支付来源
					{label: '全部', value: ''},
					{label: '小程序', value: 1},
					{label: 'h5', value: 2},
				],
				profitStatus:[
					{
						label: '全部',
						value: 0
					},
					{
						label: '未结算',
						value: 1
					},
					// {
					// 	label: '抖音商户',
					// 	value: 2
					// },
					{
						label: '已结算',
						value: 3
					}
				],
				dialogTableVisible: false,
				tableList: [],
				selectList: [{
						label: '全部',
						value: '全部'
					},
					{
						label: '已上架',
						value: '已上架'
					},
					{
						label: '已下架',
						value: '已下架'
					},
					{
						label: '已驳回',
						value: '已驳回'
					},
					{
						label: '待审核',
						value: '待审核'
					},
					{
						label: '草稿',
						value: '草稿'
					}
				],
				noDataName: 'empty',
				sceneList: [
					{
						label: '全部',
						value: ''
					},
					{
						label: '直播间',
						value: 2
					},
					{
						label: '视频页',
						value: 3
					},
					{
						label: '其他',
						value: 1
					}
				],
				stateList: [
					{
						label: '全部',
						value: ''
					},
					{
						label: '已购买',
						value: 4
					},
					{
						label: '已退款',
						value: 7
					},
					{
						label: '待支付',
						value: 2
					},
					{
						label: '退款中',
						value: 9
					}
				],
				channelAccountList: [],
				drawerFlag: false,
				detail_id: '',
				openlist:false,
				productList: [],
				drawerLearnFlag:false,
				learning_id:'',
				checkedHeadTitles:['课程标题'],
				tableHeadTitle:[],
				tableHeadTitleShow:[],
				// isShowAuthMobile: '',
				showMobileAuth: false
			}
		},
		created() {
			const times = [dayjs().subtract(6, 'day').format('YYYY-MM-DD 00:00:00'),dayjs().format('YYYY-MM-DD 23:59:59')]
			this.searchObj.start_time = times[0]
			this.searchObj.end_time = times[1]
			this.times.push(...times)
			this.tableHeadTitle = this.headerList
			this.getTableHeadTitle(true)
			this.getOrderInfos(true)
			this.getChannelAccount()
			this.getProductList()
			// this.getAuthMobile()
		},
		components: {
			Pagination,
			drawer,
			drawerLearn,
			tableToolsHead,
			// mobileDialog,
			httpsDialog
		},
		computed: {
			...mapState(['breadCrumbList', 'is_show_mobile']),
			...mapState('order', ['orderInfo']),
			cellStyle() {
				return {
					'padding': '54px 0 12px 0'
				}
			},
			isShowAuthMobile() {
				return this.is_show_mobile
			},
			// 显示页码
			showPagination(){
				if(this.orderInfo.total > 0){
					return true
				}else{
					return false
				}
			}
		},
		methods: {
			...mapActions('order', ['getOrderInfo']),
			...mapActions('export', ['createExportAPI']),
			...mapActions('withdrawal', ['channelAccount','authorCourse','wxAuthorCourseAPI','tableHeader','settings','getCompleteMobile', 'orderEdit']),
			hiddenTips(scope){
				this.$set(scope.row,'tips_status',true)
				this.$set(scope.row,'last_remark_author',scope.row.remark_author) // 修改前的备注
			},
			async showTips(scope){
				if(scope.row.last_remark_author != scope.row.remark_author){
					await this.orderEdit({
						order_id: scope.row.id,
						remark_author: scope.row.remark_author || '',
						channel_type: this.searchObj.channel_type || ''
					})
				}
				this.$set(scope.row,'tips_status',false)
				this.getOrderInfos()
			},
			// 抽屉中修改了备注
			drawerEditRmark(){
				this.getOrderInfos()
			},
			async getTableHeadTitle(flag){
				let res = await this.tableHeader()
				console.log(res,'getTableHeadTitle------',this.tableHeader(),this.checkedHeadTitles)
				if(res.data){
					this.tableHeadTitleShow = res.data
					// this.tableHeadTitleShow = this.headerList
					let objType = {
						product_title: 180,
						pay_amount: 120,
						status:100,
						talent_name:130,
						nick_nake:140,
						author_income: 110,
						pay_channel: 80
					}
					this.tableHeadTitleShow = this.tableHeadTitleShow.map(item => {
						if(objType.hasOwnProperty(item.prop)) {
							item.width = objType[item.prop]
						}
						return item
					})
					if(flag){
						this.checkedHeadTitles = ['课程标题']
						this.tableHeadTitleShow.map(item => {
							if(item.label!='课程标题'){
								this.checkedHeadTitles.push(item.label)
							}
						})
					}
					
				}else{
					this.tableHeadTitleShow = this.headerList
					this.tableHeadTitle.map(item => {
						if(item.label!='课程标题'){
							this.checkedHeadTitles.push(item.label)
						}
					})
					
				}
			},
			async handleCheckedHeadTitlesChange(e){
				console.log(e,'handleCheckedHeadTitlesChange----')
				this.checkedHeadTitles = e
				let data = e
				let setting = []
				data.map(item => {
					this.tableHeadTitle.map(key => {
						if(item==key.label) {
							let a = {
								prop:key.prop,
								label:key.label
							}
							setting.push(a)
						}
					})
				})
				console.log(setting,'setting')
				setting = JSON.stringify(setting)
				await this.settings({set_json:setting})
				this.getTableHeadTitle(false)
			},
			rowClassName({row, rowIndex}) {
				if(row[this.popHeaderList[rowIndex].prop] == 0) {
					return 'tr-hide'
				}
			},
			capitaletails(row) {
				// this.tableList= [
				// 	{
				// 		role: localStorage.getItem('name'),
				// 		profit: row.author_income
				// 	},
				// 	{
				// 		role: row.talent_name,
				// 		profit: row.talent_income
				// 	}
				// ]
				// this.dialogTableVisible = true
				this.drawerFlag = true
				this.detail_id = row.id
			},
			capitaleLearnRecords(row){
				this.drawerLearnFlag = true
				this.learning_id = row.id
				console.log(this.learning_id,'this.learning_id')
			},
			changeSize(size) {
				this.searchObj.page = size
				this.getOrderInfos()
			},
			changeTime(value, a, b) {
				console.log(this.times, 'pppp')
				this.searchObj.start_time = this.times && this.times.length ? this.times[0] : ''
				this.searchObj.end_time = this.times && this.times.length ? this.times[1] : ''
			},
			getOrderInfos(flag) {
				if(flag) {
					this.searchObj.page = 1
				}
				this.getOrderInfo(this.searchObj)
			},
			searchRes() {
				this.noDataName = 'noData'
				// this.$refs.pagination.firstPage()
				this.getOrderInfos(true)
			},
			exportExcel() {
				this.$confirm('5分钟内仅可导出一次,导出后可在导出记录中查看导出进度,导出成功的数据请在24小时内下载', '导出提示', {
					distinguishCancelAndClose: true,
					confirmButtonText: '导出',
					cancelButtonText: '取消',
					customClass: ''
				})
				.then(async() => {
					await this.createExportAPI({
						type: 1, // 1用户订单 2退款订单 3申诉订单 4发货订单 5线索订单
						search_params: {
							...this.searchObj,
							excel: 1,
							comeFrom: 2
						}
					})
					this.$router.push({
						path:  this.staticPath + "exportHistory"
					})
				})
			},
			changeScene() {
				this.getOrderInfos(true)
				this.noDataName = 'noData'
			},
			async getChannelAccount() {
				let res = await this.channelAccount()
				this.channelAccountList = res
			},
			async getProductList() {
				const postParams = {
					product_name: '',
					page:1,
					limit:200
				}
				const defaultVal = [{
					id: '',
					title: "全部"
				}]
				await this.authorCourse(postParams).then((res) =>{
					this.productList = [...defaultVal,...res.data]
				}).catch((err)=>{
					this.productList = [...defaultVal]
				})
			},
			async getAuthMobile(){
				let res = await this.getCompleteMobile()
				this.isShowAuthMobile = res.is_show
				
			},
			getUserMobileAuth(data){
				this.showMobileAuth = data
			}
		},
		watch: {
		},
	}
</script>
<style lang="less">
	@classNames: order;
	.@{classNames} {
		.el-table::before {
			background-color: transparent;
		}
		.tr-hide {
			display: none;
		}
		.@{classNames}_operation_title {
			margin-right: 12px;
			color: #1989FA;
			font-size: 14px;
			cursor: pointer;
			// &:not(:last-child) {
			// 	margin-right: 12px;
			// }

		}
	}
	.@{classNames}_oprtation {
		flex: 1 0 auto;
		display: flex;
		justify-content: flex-start;
		.el-button--primary {
			margin:0 6px;
		}
	}
	.total_sums{
		position: absolute;
		top:50%;
		transform: translateX(-50%);
		right: 20px;
		font-weight: normal;
		color: #606266;
	}
	.@{classNames}_detailed {
		padding: 20px 24px;
		width: 400px;
		box-sizing: border-box;
		.el-dialog__body {
			padding: 0;
		}
		.el-dialog__header {
			padding: 0 0 13px 0;
			.el-dialog__title {
				font-size: 16px;
				font-weight: 500;
				color: #485059;
			}
		}
	}
	.@{classNames}_con_table {
		.@{classNames}_empty {
			position: absolute;
			top: 0px;
			left: 0;
			width: 1000px;
			height:10px;
			background: #fff;
			z-index: 100;
		}
		.@{classNames}_item {
			position: absolute;
			top: 10px;
			left: 0;
			width: 1000px;
			padding: 0 12px;
			height: 32px;
			background: #F5F7FA;
			color: #888a95;
    		font-size: 12px;
			line-height: 32px;
			display: flex;
			justify-content: flex-start;
			z-index: 1000;
			span {
				&:not(:first-child) {
					margin-left: 12px;
				}
			}
		}
		.buy {
			min-width: 66px;
			max-width: 100px;
			height: 24px;
			border-radius: 12px;
			border: 1px solid #5ADDB3;
			font-size: 14px;
			color: #2DC695;
			line-height: 24px;
			text-align: center;
			
		}
	}
</style>
<style lang='less' scoped>
	@classNames: order;

	.@{classNames} {
		display: flex;
		flex-direction: column;
		height: 100%;
		.@{classNames}_statistics {
			flex-shrink: 0;
			padding: 20px 0;
			box-sizing: border-box;
			span {
				font-size: 16px;
				font-weight: 600;
				color: #485059;
				line-height: 16px;
				&:last-child {
					margin-left: 60px;
				}
			}
		}
		.@{classNames}_search {
			display: flex;
			flex-shrink: 0;
			padding-bottom: 20px;
			box-sizing: border-box;
			border-bottom: 1px solid #F8F8FB;
			flex-wrap: wrap;
			justify-content: space-between;
			.@{classNames}_search_con {
				display: flex;
				flex-wrap: wrap;
				.@{classNames}_search_con_item {
					display: flex;
					align-items: center;
					margin-right: 16px;
					margin-bottom: 12px;
					.@{classNames}_search_con_item_title {
						white-space: nowrap;
						font-size: 14px;
						color: #606266;
						margin-right: 12px;
					}
				}
			}
		}
		.@{classNames}_con {
			flex: 1;
			display: flex;
			flex-direction: column;
			.@{classNames}_con_table {
				.@{classNames}_empty {
					position: absolute;
					top: 0px;
					left: 0;
					width: 700px;
					height:10px;
					background: transparent;
					z-index: 100;
				}
				.@{classNames}_item {
					position: absolute;
					top: 10px;
					left: 0;
					width: 1000px;
					padding: 0 12px;
					height: 32px;
					background: transparent;
					// background: #F5F7FA;
					color: #888a95;
					font-size: 12px;
					line-height: 32px;
					display: flex;
					justify-content: flex-start;
					z-index: 1000;
					span {
						&:not(:first-child) {
							margin-left: 12px;
						}
					}
				}
			}
		}
		.refund{
			color: #888a95;
			border: 1px solid #888a95;

		}
		.refund1{
			color: orange;
			border: 1px solid orange;
		
		}
	}
	/deep/ .el-table__row {
		>td {
			position: relative;
			&::after{
				content: '';
				position: absolute;
				top: 10px;
				left: 0;
				width: 100%;
				height: 32px;
				background: #f5f7fa;
			}
		}
	}
</style>
